import { render, staticRenderFns } from "./UserSegmentList.vue?vue&type=template&id=770909d4&"
import script from "./UserSegmentList.vue?vue&type=script&lang=js&"
export * from "./UserSegmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports